import { render, staticRenderFns } from "./OnboardingFormationTopic.vue?vue&type=template&id=85353a8a&scoped=true&"
import script from "./OnboardingFormationTopic.vue?vue&type=script&lang=js&"
export * from "./OnboardingFormationTopic.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingFormationTopic.vue?vue&type=style&index=0&id=85353a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85353a8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
